/* global angular */

require('../../directives/currency-input-formatter.directive.js')
require('../../directives/update-on-enter.directive.js')

angular.module('NumberInputCmp', ['currencyInputFormatterCmp', 'updateOnEnterCmp'])
  .component('numberInput', {
    template: require('./number-input.component.tpl.html'),
    controller: NumberInputCtrl,
    controllerAs: 'vm',
    bindings: {
      inputId: '@',
      ngModel: '=',
      ngDisabled: '<',
      onFocused: '&',
      onBlured: '&',
      defaultValue: '<',
      ngMin: '<',
      ngMax: '<',
      onChanged: '&',
      ngModelOptions: '<',
      labelText: '@',
      inputRf: '@',
      allowEmpty: '@',
      resetCallbackFn: '&',
      trackElement: '@'
    }
  })

NumberInputCtrl.$inject = ['$timeout']

function NumberInputCtrl ($timeout) {
  var vm = this

  vm.$onInit = function () {
    vm.inputId = vm.inputId || 'number-input-' + guid()
    vm.ngModelOptions = vm.ngModelOptions || {}
    vm.allowEmpty = vm.allowEmpty || 'true'
  }

  vm.$onChanges = function (changesObj) {
    if (changesObj.inputId) {
      vm.inputId = vm.inputId || 'number-input-' + guid()
    }
    if (changesObj.ngModelOptions) {
      vm.ngModelOptions = vm.ngModelOptions || {}
    }
    if (changesObj.allowEmpty) {
      vm.allowEmpty = vm.allowEmpty || 'true'
    }
  }

  /* Hack that forces IE to behave like other browsers:
   * Pressing Enter in input fires onchange event. */
  vm.detectEnterIE = function (e) {
    e = e || window.event
    const keyNum = e.keyCode || e.which

    if (keyNum === 13) {
      /* Fire blur event that fires onchange event. */
      e.srcElement.blur()
    }
  }

  vm.onInputChange = function () {
    $timeout(function () {
      vm.onChanged()
    }, 0)
  }

  vm.onFocus = function (e) {
    var el = e.target || e.srcElement
    el.setSelectionRange(0, el.value.length)
    $timeout(function () {
      vm.onFocused()
    }, 0)
  }

  vm.onBlur = function () {
    $timeout(function () {
      vm.onBlured()
    }, 0)
  }

  function guid () {
    function s4 () {
      return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1)
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4()
  }
}
